import type { BadgeType } from '@/types'

interface BadgeProps {
  type: BadgeType
  size?: 'sm' | 'md'
  className?: string
}

const badgeConfig: Record<BadgeType, { bg: string; text: string; label: string }> = {
  nearest: {
    bg: 'bg-[var(--color-badge-nearest)]/10',
    text: 'text-[var(--color-badge-nearest)]',
    label: 'Nearest',
  },
  fastest: {
    bg: 'bg-[var(--color-badge-fastest)]/10',
    text: 'text-[var(--color-badge-fastest)]',
    label: 'Fastest',
  },
  popular: {
    bg: 'bg-[var(--color-badge-popular)]/10',
    text: 'text-[var(--color-badge-popular)]',
    label: 'Popular',
  },
  new: {
    bg: 'bg-[var(--color-badge-new)]/10',
    text: 'text-[var(--color-badge-new)]',
    label: 'New',
  },
  free_delivery: {
    bg: 'bg-[var(--color-badge-free-delivery)]/10',
    text: 'text-[var(--color-badge-free-delivery)]',
    label: 'Free delivery',
  },
}

export function Badge({ type, size = 'sm', className = '' }: BadgeProps) {
  const config = badgeConfig[type]
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs/4',
    md: 'px-2.5 py-1 text-sm/5',
  }

  return (
    <span
      className={`
        inline-flex items-center rounded-md font-semibold tracking-tight
        ${config.bg} ${config.text} ${sizeClasses[size]}
        ${className}
      `}
    >
      {config.label}
    </span>
  )
}
